import { render, staticRenderFns } from "./FirstLoginView.vue?vue&type=template&id=77b4e563&scoped=true&lang=pug&"
import script from "./FirstLoginView.vue?vue&type=script&lang=js&"
export * from "./FirstLoginView.vue?vue&type=script&lang=js&"
import style0 from "./FirstLoginView.vue?vue&type=style&index=0&id=77b4e563&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4e563",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
